import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import styles from "./Auth.module.css";

const MailIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2"/>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
  </svg>
);

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [resetSuccess, setResetSuccess] = useState(false);
  const { resetPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await resetPassword(email);
      setResetSuccess(true);
    } catch (error) {
      console.log(error.message);
      if (error.code === "functions/invalid-argument") {
        setError("Please enter a valid email address.");
      } else if (error.code === "functions/internal") {
        setError("Failed to send reset email. Please try again.");
      } else {
        setError("An error occurred. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.authContainer}>
        <div className={styles.authCard}>
          <h1>Reset Password</h1>
          <p className={styles.subtitle}>
            Enter your email and we'll send you a reset link
          </p>

          {resetSuccess ? (
            <>
              <div className={styles.successMessage}>
                A password reset link has been sent to <strong>{email}</strong>. Please check your inbox and spam folder.
              </div>
              <div className={styles.authLinks}>
                <p className={styles.authLink}>
                  <Link to="/login">Return to login</Link>
                </p>
              </div>
            </>
          ) : (
            <>
              <form onSubmit={handleSubmit} className={styles.form}>
                <div className={styles.inputGroup}>
                  <div className={styles.inputWrapper}>
                    <span className={styles.inputIcon}>
                      <MailIcon />
                    </span>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      className={styles.input}
                      placeholder="Email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      autoComplete="email"
                    />
                  </div>
                </div>

                {error && <div className={styles.errorMessage}>{error}</div>}

                <button
                  type="submit"
                  className={styles.submitBtn}
                  disabled={loading}
                >
                  {loading ? (
                    <span className={styles.loading}>
                      <span className={styles.spinner}></span>
                      Sending...
                    </span>
                  ) : (
                    "Send Reset Link"
                  )}
                </button>
              </form>

              <div className={styles.authLinks}>
                <p className={styles.authLink}>
                  <Link to="/login">Back to login</Link>
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
